import { render } from "./EstacaoComponent.vue?vue&type=template&id=06c2ed6a"
import script from "./EstacaoComponent.vue?vue&type=script&lang=js"
export * from "./EstacaoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__